import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useT } from "@/lib/i18n";

import { useSeo } from "@/lib/seo";
const CARDS = [
  {
    to: "/academy",
    img: "/landing-sandlab.jpg",
    pos: "object-[center_20%] md:object-[center_35%]",
    title: "The Sand Lab",
    subtitle: "Beach Volleyball Academy",
    testid: "landing-card-sandlab",
    ctaKey: "landing_cta_academy",
  },
  {
    to: "/naos",
    img: "/landing-naos.jpg",
    pos: "object-[center_20%] md:object-center",
    title: "Ν.Α.Ο. Σούδας",
    subtitle: "Volleyball",
    testid: "landing-card-naos",
    ctaKey: "landing_cta_naos",
  },
];

export default function LandingPage() {
  useSeo({ path: "/" });
  const { t } = useT();
  return (
    <main className="min-h-screen bg-slate-950 flex flex-col" data-testid="landing-page">
      <div className="flex-1 grid grid-cols-1 md:grid-cols-2 min-h-screen">
        {CARDS.map((c, i) => (
          <Link
            key={c.to}
            to={c.to}
            data-testid={c.testid}
            className="group relative overflow-hidden flex items-end justify-center min-h-[70vh] md:min-h-screen focus:outline-none"
          >
            <img
              src={c.img}
              alt=""
              className={`absolute inset-0 h-full w-full object-cover ${c.pos} transition-transform duration-700 ease-out group-hover:scale-105`}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-950/70 via-transparent to-transparent" />
            <span className="sr-only">{c.title} — {c.subtitle}</span>
            <div className="relative z-10 flex flex-col items-center text-center px-6 pt-[52vh] md:pt-[62vh] pb-10">
              <span className="inline-flex items-center gap-2 rounded-full bg-white/10 backdrop-blur px-6 py-3 text-white font-bold border border-white/25 transition-all group-hover:bg-white group-hover:text-slate-900">
                {t(c.ctaKey)} <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
              </span>
            </div>
            {i === 0 && <div className="hidden md:block absolute right-0 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-white/70 to-transparent" />}
          </Link>
        ))}
      </div>
    </main>
  );
}
